import React, { useEffect, useState } from "react";
import Indexdasboard from "../../components/dashboard/IndexDashbord";
import { Api_Token } from "../../util/Api";
import { StyledTableCell, StyledTableRow } from "../../assets/style/Table";
import {
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Card,
  TablePagination,
  IconButton,
  Grid,
  CardContent,
  Divider,
  Pagination,
} from "@mui/material";
import ModelUserCaisse from "../../components/popup/ModelUserCaisse";
import DeleteConfirmation from "../../components/popup/deleteConfirmation";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import TitreGraphik from "../../components/Typography/TitreGraphik";
import { useNavigate } from "react-router";
import CustomAlert from "../../components/Alert/AlertCustomer";
import { CheckEmailRegulaire } from "../../services/functions";
import ButtonSimple from "../../components/Button/ButtonSimple";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LabelTypography from "../../components/Typography/LabelTypography";
export default function CommercielManagementPage() {
  return <Indexdasboard Children={<CommercielManagement />} />;
}

function CommercielManagement() {
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    nomUser: "",
    PrenomUser: "",
    Role: "commercial",
    idCaisse: null,
  });
  const [userToDelete, setUserToDelete] = useState(null);
  const [alertState, setAlertState] = useState("initial");
  const [alertMessage, setAlertMessage] = useState("");
  const [formError, setFormError] = useState({});
  const { t } = useTranslation();
  const navigate = useNavigate();

  const fetchUsers = async (currentPage, rowsPerPage) => {
    try {
      const response = await Api_Token.get(
        `users/getUserWithCaisse?page=${currentPage + 1}&perPage=${rowsPerPage}`
      );
      setUsers(response.data.data);
      setTotalCount(response.data.total);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleDeleteUser = async () => {
    try {
      await Api_Token.delete(`/users/deleteUser/${userToDelete.id}`);
      setAlertState("success");
      setAlertMessage("User deleted successfully!");
      fetchUsers(page, rowsPerPage);
      handleCloseDeleteDialog();
    } catch (error) {
      setAlertState("error");
      setAlertMessage("Error deleting user: " + error.message);
      console.error("Error deleting user:", error);
    }
  };

  useEffect(() => {
    fetchUsers(page, rowsPerPage);
  }, [page, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenModal = (user) => {
    setFormData(user);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setFormData({
      id: null,
      nomUser: "",
      PrenomUser: "",
      Role: "commercial",
      idCaisse: null,
    });
  };

  const handleOpenDeleteDialog = (user) => {
    setUserToDelete(user);
    setOpenDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setUserToDelete(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const Data = new FormData(e.target);
    const error = {};
    if (!formData.id) {
      if (!CheckEmailRegulaire(e.target.email.value)) {
        error.email = "email invalide";
        setFormError(error);
        return;
      }
      if (e.target.password.value.length < 8) {
        error.password = "Password must be at least 8 characters long";
        setFormError(error);
        return;
      }
    }
    Data.append("idCaisse", formData.idCaisse);

    try {
      if (formData.id) {
        await Api_Token.post(`/users/updateUser/${formData.id}`, Data);
        setAlertState("success");
        setAlertMessage(t("User updated successfully!"));
      } else {
        await Api_Token.post("users/createUser", Data);
        setAlertState("success");
        setAlertMessage(t("User created successfully!"));
      }
      fetchUsers(page, rowsPerPage);
      handleCloseModal();
    } catch (error) {
      setAlertState("error");
      setAlertMessage(t("Error submitting form: ") + error.message);
      console.error("Error submitting form:", error);
    }
  };

  return (
    <Box>
      <TitreGraphik>
        <span onClick={() => navigate(-1)}>⬅</span>
        {t("Gestion Users")}
      </TitreGraphik>
      <Card
        sx={{
          padding: "2%",
          marginTop: "2%",
          display: { xs: "none", md: "flex" },
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ButtonSimple
              variant="contained"
              onClick={() => handleOpenModal({})}
            >
              {t("Add New User")}
            </ButtonSimple>
          </Grid>
          <Grid item xs={12}>
            <TableContainer>
              <Table aria-label="users table">
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell align="center">{t("ID")}</StyledTableCell>
                    <StyledTableCell align="center">{t("Nom")}</StyledTableCell>

                    <StyledTableCell align="center">
                      {t("Caisse")}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {t("Role")}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {t("Actions")}
                    </StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {users.map((user) => (
                    <StyledTableRow key={user.id}>
                      <StyledTableCell align="center">
                        <Link
                          to={`/userStatistique/${user.id}`}
                          style={{ textDecoration: "none", color: "inherit" }}
                        >
                          #{user.id}
                        </Link>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {user.name}
                      </StyledTableCell>

                      <StyledTableCell align="center">
                        {user.caisse?.nomCaisse || "N/A"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {user.Role}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <IconButton onClick={() => handleOpenModal(user)}>
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          color="error"
                          onClick={() => handleOpenDeleteDialog(user)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TableContainer>
          </Grid>
        </Grid>
      </Card>
      <Box
        sx={{
          padding: "2%",
          marginTop: "3%",
          display: { xs: "flex", md: "none" },
        }}
      >
        <Box sx={{ width: "100%" }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <ButtonSimple
                variant="contained"
                onClick={() => handleOpenModal({})}
                sx={{ width: "100%" }}
              >
                {t("Add New User")}
              </ButtonSimple>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                {users.map((user) => (
                  <Grid item xs={12} sm={6} md={4} key={user.id}>
                    <Card
                      variant="outlined"
                      sx={{ width: "100%", margin: "auto" }}
                    >
                      <CardContent>
                        <LabelTypography textAlign="center">
                          {t("ID")}: #{user.id}
                        </LabelTypography>
                        <Divider sx={{ margin: "10px 0" }} />
                        <LabelTypography color="text.primary">
                          {t("Nom")}: {user.name}
                        </LabelTypography>
                        <LabelTypography color="text.primary">
                          {t("Caisse")}: {user.caisse?.nomCaisse || "N/A"}
                        </LabelTypography>
                        <LabelTypography color="text.primary">
                          {t("Role")}: {user.Role}
                        </LabelTypography>
                        <Divider sx={{ margin: "10px 0" }} />
                        <Box display="flex" justifyContent="center">
                          <IconButton onClick={() => handleOpenModal(user)}>
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            color="error"
                            onClick={() => handleOpenDeleteDialog(user)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
                <Grid item xs={12}>
                  <Box
                    sx={{
                      marginTop: "3%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Pagination
                      count={Math.ceil(totalCount / rowsPerPage)}
                      onChange={(event, newPage) => {
                        setPage(newPage - 1); // Adjust for 0-based indexing
                      }}
                      variant="outlined"
                      color="primary"
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <ModelUserCaisse
        open={openModal}
        onClose={handleCloseModal}
        handleSubmit={handleSubmit}
        data={formData}
        formError={formError}
        setFormData={setFormData}
      />

      <DeleteConfirmation
        open={openDeleteDialog}
        onClose={handleCloseDeleteDialog}
        confirme={handleDeleteUser}
        message={t("Etes-vous sûr de vouloir supprimer cet utilisateur ?")}
      />

      <CustomAlert
        open={alertState !== "inisial"}
        onClose={() => {
          setAlertState("inisial");
        }}
        etat={alertState}
        message={alertMessage}
      />
    </Box>
  );
}
